import React from "react"
import './cardFeaturedPro.scss'

import { Link } from 'react-router-dom'
import AvaliationStar from '../avaliationStars/avaliationStars'

import userLogo from '../../assets/user_logo.svg'

export default class CardFeaturedPro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const {
            name, photo, mainJob, avaliationStar, link
        } = this.props;

        return (
            <Link to={"/profile/" + link} style={{color: '#5F5F5F'}}>
                <div className={'cardFeatured'} style={{zIndex: '-1'}}>
                    <div className={'imgContainer'}>
                        <img src={photo ? photo : userLogo} alt={name} />
                    </div>
                    <div className={'content'} style={{zIndex: '-1'}}>
                        <h1>{name ? name : 'Nome de usuário'}</h1>
                        {/* <div>{mainJob ? mainJob.player.anuncioses.map(s => <span className="tag">{s.skills.name}</span>) : null}</div> */}
                        {mainJob.length ? mainJob.map((anun, i) => (
                            anun.active? <span key={i}>{anun.skills.name}</span> : null
                        )) : <span>Habilidade</span>}
                        <AvaliationStar avaliation={avaliationStar ? avaliationStar : 0} />
                    </div>
                </div>
            </Link>
        )
    }
}
